import * as React from 'react';

import styled from '@emotion/styled';

const BackToTopBtn = styled.button`
  background: #FBFBFB;
  font-weight: bold;
  font-size: 1.7rem;
  padding: 1rem 0;
`;

const ArrowUp = ({ size = 22, color = '#32BA55' }) => (
  <svg
    // tslint:disable-next-line:no-http-string
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 19V6M5 12l7-7 7 7" />
  </svg>
);

class BackToTop extends React.Component {
  backToTop = () => {
    if (typeof window !== `undefined`) {
      window.scrollTo(0, 0);
    }
  };

  render() {
    return (
      <BackToTopBtn onClick={this.backToTop}>
        <ArrowUp /> Back to Top
      </BackToTopBtn>
    );
  }
}

export default BackToTop;
